// @ts-nocheck
import {
  Alert,
  CircularProgress,
  Divider,
  IconButton,
  Rating,
  Tooltip,
  Typography,
  styled,
} from "@mui/material";
import { alpha, Box, fontSize, maxWidth, padding } from "@mui/system";
import PropTypes from "prop-types";
import { getCssVariableHandler } from "../../utils/styles/getCssVariables";
import {
  getEmailSanitized,
  phoneNumberFormat,
} from "../../utils/methods/formatters";
import React, { useCallback, useMemo, useState } from "react";
import UnderlineButton from "../Custom/UnderlineButton";
import CustomHelper from "../Helper/CustomHelper";
import { useDispatch, useSelector } from "react-redux";
import {
  openDirectSMSModalAction,
  openReportModalAction,
  openSendSmsModalDirectAction,
  triggerEmailConsentAction,
  triggerSmsConsentAction,
} from "../../store/actions/sms/sms";
import { USER_ROLES, userRoles } from "../../staticData/userRoles";
import { CONTRACTOR_TYPE_3RD_PARTY } from "../../utils/constants/nmaes";
import { contractorTypesFrontend } from "../../pages/contractors/components/AddContractorForms/formSchemas/addContractorStep1Schema";
import { CustomIconButton } from "../Custom/CustomIconButton";
import { Edit, Textsms } from "@mui/icons-material";
import { alertDialogAciton } from "../../store/actions/auth";
import { refreshPositionAction } from "../../store/actions/eventRequestDetails";
import { isUserRole, isActiveRole } from "../../utils/methods/storeFunc";
import { isNull, isUndefined } from "lodash";
import {
  getContractorAlertTextColor,
  getNewlyAssignedContractorColor,
} from "../../utils/methods/contractors/contractorUtils";
import WarningAmberIcon from "@mui/icons-material/WarningAmber";
import {
  CLEAR_ADD_CONTRACTOR,
  SETUP_EDIT_CONTRACTOR_FAILURE,
  SETUP_EDIT_CONTRACTOR_REQUEST,
} from "../../store/constants/contractor";
import { getAllPositions } from "../../store/actions/positions";
import AddContractorModal, {
  prefillEditContractorFlowHandler,
} from "../../pages/contractors/components/AddContractorModal";
import { getContractorByIdAction } from "../../store/actions/contractor";
import SetContractorRatingModal from "../../pages/contractors/components/SetContractorRatingModal";
import { fetchContractorRatingByIdAction } from "../../store/actions/contractorRatings";
import CopyButton from "./CopyButton";
import ContractorRatingNotes from "../ContractorRating/ContractorRatingNotes";
import ContractorShows from "./ContractorShows";
import { fetchContractorShowsAction } from "../../store/actions/contractorShows";
import {
  openManageApprovalModalAction,
  openViewDocumentModalAction,
} from "../../store/actions/config/contractorLink";
import { WORKMARKET_CONTRACTOR_TYPES } from "../../utils/constants/configs";

export const CustomTooltip = styled((props) => <Tooltip {...props} />)(
  () => ({}),
);

/**
 * 10DLC de origem (AWS End User Messaging, ca-central-1), vinculado à opt-out list
 * `showphaze`. É o número para o qual o contractor manda START para voltar a receber
 * SMS depois de um STOP — a AWS remove da opt-out list automaticamente.
 */
const SMS_ORIGINATION_DISPLAY = "+1 (412) 618-1334";

/**
 * How many proficient roles the card lists before collapsing the rest into
 * "+N". The client asked for "1-3 roles" (2026-08-12); the data has no
 * proficiency ranking, so these are simply the first ones registered.
 */
const MAX_PROFICIENT_ROLES = 3;

export const ContactTool = ({
  children,
  data,
  disable,
  placement,
  bottomComponent = null,
  showName = false,
  showPreferredName = true,
  disableDetails = false,
  showConsentBtns = false,
  rowData = {},
  isEventDetails = false,
  isSessionManagemnt = false,
  afterEditFlaggedRemark = () => {},
  enableEditContractor = false,
  closeAddContractorModalHandlerCallback = () => {},
  isDM = false,
  hideApprovalsButton = false,
  showCompletionStatus = false,
  /**
   * Hides the pencils that edit the Flagged / Restricted remarks.
   *
   * They open the Report modal, which WRITES. A surface with no per-row
   * refresh would keep showing the old remark after a successful edit, so it
   * opts out instead of shipping a button that looks broken.
   */
  hideRemarkEditButtons = false,
  /**
   * Keeps the card visible for someone with neither email nor phone.
   *
   * Most screens skip the card entirely in that case (see the early return
   * below) — it would be two "Missing Information" chips. On a search surface
   * that person is precisely the one being looked up, and the card still
   * carries type, IDs, HR approval and the remarks.
   */
  showWithoutContactInfo = false,
}) => {
  // static data start...
  const showAddContractorsModalInit = React.useMemo(() => {
    return {
      show: false,
      isCreating: false,
      isEditing: false,
      isViewing: false,
    };
  }, []);
  const [updatedData, setUpdatedData] = useState(null);
  const [showRatingModal, setShowRatingModal] = useState(false);
  const [showAddContractorsModal, setShowAddContractorsModal] = useState(
    showAddContractorsModalInit,
  );
  const isThirdParty = useMemo(() => {
    return (
      rowData?.contractorType == CONTRACTOR_TYPE_3RD_PARTY.OUTSOURCED ||
      rowData?.contractorType == CONTRACTOR_TYPE_3RD_PARTY.THIRD_PARTY
    );
  }, [rowData]);
  const showSendConsetEmail = useMemo(() => {
    return (
      rowData?.smsPermissionStatus == false &&
      rowData?.smsConsentStatusBySms == false
    );
  }, [rowData]);

  const showSmsConset = useMemo(() => {
    return rowData?.smsConsentStatusBySms == false;
  }, [rowData]);

  /**
   * Estado do consent de SMS, mostrado no card de contato (06/08/2026).
   *
   * Antes o admin não enxergava nada: o botão "Send SMS Consent" simplesmente sumia
   * quando a pessoa já tinha confirmado, e nada indicava quem tinha dado STOP. Isso
   * produzia dois problemas reais no chamado do Robert:
   *   1. ele reportava gente que JÁ tinha aceitado (o Zac aceitou 28/07 e foi reportado
   *      em 29/07), porque a tela não mostra o aceite;
   *   2. quem deu STOP virava beco sem saída — o botão some e ninguém sabe que a volta
   *      existe.
   *
   * A volta do STOP é auto-serviço por desenho: o contractor manda START para o 10DLC e
   * a AWS remove ele da opt-out list sozinha (a lista `showphaze` está vinculada ao
   * número), e o nosso handler de inbound zera `smsOptedOut`. NÃO existe (nem deve
   * existir) botão de admin pra desfazer um STOP: remover alguém da opt-out list sem
   * aceite registrado é exposição a TCPA. Por isso aqui a gente mostra a INSTRUÇÃO.
   */
  const smsConsentInfo = useMemo(() => {
    if (!rowData) return null;
    if (rowData?.smsOptedOut === true) {
      return {
        label: "Opted out (replied STOP)",
        color: "#ef5350",
        hint: `To receive texts again they must text START to ${SMS_ORIGINATION_DISPLAY}. We cannot re-enable it for them.`,
      };
    }
    if (rowData?.smsConsentStatusBySms === true) {
      return { label: "Consent confirmed by reply", color: "#66bb6a", hint: null };
    }
    if (rowData?.smsPermissionStatus === true) {
      return { label: "Consent given in app", color: "#66bb6a", hint: null };
    }
    return {
      label: "Consent not confirmed",
      color: "#ffa726",
      hint: 'Use "Send SMS Consent" to ask them to reply 1.',
    };
  }, [rowData]);

  const contractorType = useMemo(() => {
    if (!rowData?.contractorType) return null;
    return contractorTypesFrontend?.[rowData?.contractorType];
  }, [rowData]);

  const shouldShowContracts = useMemo(() => {
    return ["V.C.", "w2", "1099"]?.includes(rowData?.contractorType);
  }, [rowData?.contractorType]);

  // Fallback tolerante pro nome exibido no popup: alguns docs de `users`
  // (migrados/incompletos) não têm firstName/lastName, e cada tela compõe
  // `data.name` a partir deles ($concat null-propaga no backend). Usa o que
  // existir no row pra nunca mostrar o campo em branco.
  const displayName = useMemo(() => {
    const candidates = [
      data?.name,
      rowData?.fullName,
      rowData?.contractorName,
      rowData?.preferredName,
      rowData?.name,
    ];
    const found = candidates.find(
      (v) => typeof v === "string" && v.trim() !== "",
    );
    return found ? found.trim() : null;
  }, [data?.name, rowData]);

  // Preferred name pro popup: usa o `preferredname` (cru) quando o endpoint
  // manda, senão cai no `preferredName` composto (rows de session vêm só com
  // o composto). Trim mata o caso " Sobrenome" (preferredName '' no banco).
  const preferredDisplay = useMemo(() => {
    const v = rowData?.preferredname || rowData?.preferredName;
    return typeof v === "string" && v.trim() !== "" ? v.trim() : null;
  }, [rowData]);

  const contractorId = useMemo(() => {
    if (!rowData?.profileId) return null;
    return rowData?.profileId;
  }, [rowData]);

  /** Home city/state as "Nashville, TN" — either half may be missing. */
  const homeLocation = useMemo(() => {
    const parts = [rowData?.city, rowData?.state]
      .map((v) => (typeof v === "string" ? v.trim() : ""))
      .filter(Boolean);
    return parts.length ? parts.join(", ") : null;
  }, [rowData?.city, rowData?.state]);

  /**
   * Roles the contractor is set up to work (client request 2026-08-12: "1-3
   * roles they are proficient in").
   *
   * Source is `proficientRoles`, built by the backend from `preferredPositions`
   * — the positions the admin registers with a rate each. Nothing in the data
   * ranks proficiency, so we keep registration order and show the count of what
   * is hidden instead of inventing a ranking. `rolesWorked` (free text from the
   * contractor form) is the fallback for people with no positions registered.
   */
  const allProficientRoles = useMemo(() => {
    const fromPositions = Array.isArray(rowData?.proficientRoles)
      ? rowData.proficientRoles
      : [];
    const cleaned = fromPositions
      .map((r) => (typeof r === "string" ? r.trim() : ""))
      .filter(Boolean);
    if (cleaned.length) return [...new Set(cleaned)];

    const freeText =
      typeof rowData?.rolesWorked === "string" ? rowData.rolesWorked.trim() : "";
    if (!freeText) return [];
    // free text, so the separator is whatever the person typed
    return [
      ...new Set(
        freeText
          .split(/[,;/|]+/)
          .map((r) => r.trim())
          .filter(Boolean),
      ),
    ];
  }, [rowData?.proficientRoles, rowData?.rolesWorked]);

  const proficientRoles = useMemo(
    () => allProficientRoles.slice(0, MAX_PROFICIENT_ROLES),
    [allProficientRoles],
  );
  const extraRolesCount = Math.max(
    0,
    allProficientRoles.length - MAX_PROFICIENT_ROLES,
  );

  const workmarketId = useMemo(() => {
    if (WORKMARKET_CONTRACTOR_TYPES?.includes(rowData?.contractorType)) {
      if (rowData?.workBookId) {
        return rowData?.workBookId;
      } else {
        return "NA";
      }
    } else {
      return null;
    }
  }, [rowData?.workBookId, rowData?.contractorType]);

  const showMessageIcon = useMemo(() => {
    // if (getEmailSanitized({ email: rowData?.email }) == "") return false;
    // else return true;
    return true;
  }, []);

  const missingInformation = useMemo(() => {
    return getNewlyAssignedContractorColor({ data: rowData }) == null
      ? false
      : true;
  }, [rowData]);

  // const canShowCompletionStatus = useMemo(() => {
  //   return (
  //     [
  //       "isPersonalInformationAdded",
  //       ...(isNull(workmarketId) ? [] : ["workBookId"]),
  //       "isRoleInformationAdded",
  //       "smsPermissionStatus",
  //       "smsConsentStatusBySms",
  //       "isAgreementAccepted",
  //     ]?.every((i) => !isUndefined(rowData?.[i]) && !isNull(rowData?.[i])) &&
  //     showCompletionStatus
  //   );
  // }, [rowData, showCompletionStatus, workmarketId]);

  const { consetEmailLoading, consetSMSLoading } = useSelector(
    (state) => state?.smsReducer,
  );
  const { eventInfo } = useSelector((state) => state?.eventRequestDetails);
  const loggedInUser = useSelector((state) => state?.auth);
  /**
   * Id the internal rating is keyed by — used for BOTH the read below and the
   * write in the modal. They must be the same key: reading by `rowData._id`
   * while writing by `contractorId` looks exactly like "I saved and it didn't
   * stick". Session/assign rows carry the person under a different key, hence
   * the same variants the other actions on this card accept.
   */
  const ratingContractorId = useMemo(() => {
    // ⚠️ `_id` LAST, same order as every other action on this card. On shift
    // rows (Session Management, Assign Coordinator) `rowData._id` is the
    // positionData subdocument — the SHIFT, not the person. While the rating
    // was read-only that only meant "stars stuck at 0"; now it is also the
    // write key, and `upsert` only validates ObjectId shape, so a shift id
    // would happily create a rating document nobody can ever read back.
    const id =
      rowData?.outSourceContractorId ||
      rowData?.contractorId ||
      rowData?.assignedContractor ||
      rowData?._id;
    return id ? String(id) : null;
  }, [rowData]);

  const internalRating = useSelector((s) =>
    ratingContractorId
      ? s.contractorRatings?.byContractorId?.[ratingContractorId]
      : undefined,
  );
  const dispatch = useDispatch();

  /**
   * Shows the person worked — client request 2026-08-21, five past and five
   * upcoming. Keyed by the SAME id as the rating (`ratingContractorId`), for
   * the same reason: on shift rows `rowData._id` is the positionData subdocument
   * — the shift, not the person — and querying by it would quietly return an
   * empty list that reads as "this contractor has never worked".
   *
   * ⚠️ Admin and Super Admin only, and deliberately narrower than the rating
   * block above (which includes Coordinator): the whole `big-search` controller
   * is `@Roles('Admin', 'Super Admin')`, so a coordinator hovering a name would
   * fire a 403 on every card. Everyone else simply does not see the block.
   */
  const canSeeShows = Boolean(
    ratingContractorId &&
      isUserRole(USER_ROLES.SUPERADMIN, USER_ROLES.ADMIN) &&
      !isActiveRole(USER_ROLES.FREELANCE_EC),
  );

  const showsEntry = useSelector((s) =>
    canSeeShows
      ? s.contractorShows?.byContractorId?.[ratingContractorId]
      : undefined,
  );
  const showsLoading = useSelector((s) =>
    canSeeShows
      ? Boolean(s.contractorShows?.loading?.[ratingContractorId])
      : false,
  );

  /**
   * Same roles that already SEE the rating (the endpoint's RolesGuard 403s
   * anyone else), and only where we have an id to write against.
   */
  const canEditInternalRating = Boolean(
    ratingContractorId &&
      isUserRole(
        USER_ROLES.SUPERADMIN,
        USER_ROLES.ADMIN,
        USER_ROLES.COORDINATOR,
      ),
  );

  /**
   * Loads the rating when the card opens, unless the screen already batched it.
   *
   * Only the Contractors page and Big Search prefetch ratings; everywhere else
   * the store was empty, so the stars rendered 0 for everyone — "not loaded"
   * reading as "rated zero" on the screens where the admin actually works.
   * Fetching on open (once per person, the reducer caches) fixes them all at
   * the cost of one request per hover, instead of teaching each list to batch.
   */
  const loadInternalRatingIfNeeded = useCallback(() => {
    if (!canEditInternalRating) return;
    if (internalRating !== undefined) return;
    dispatch(
      fetchContractorRatingByIdAction({ contractorId: ratingContractorId }),
    );
  }, [canEditInternalRating, internalRating, ratingContractorId, dispatch]);

  /**
   * Same fetch-on-open + cache-by-id contract as the rating above, and for the
   * same reason: this card is a tooltip, so it unmounts as soon as the pointer
   * leaves. Fetching on mount would re-query on every hover of an admin
   * scanning a list. The `!== undefined` guard also covers the failure entry,
   * so a structural 403 is asked once, not once per hover.
   */
  const loadShowsIfNeeded = useCallback(() => {
    if (!canSeeShows) return;
    if (showsEntry !== undefined) return;
    if (showsLoading) return;
    dispatch(fetchContractorShowsAction({ contractorId: ratingContractorId }));
  }, [canSeeShows, showsEntry, showsLoading, ratingContractorId, dispatch]);

  const onCardOpen = useCallback(() => {
    loadInternalRatingIfNeeded();
    loadShowsIfNeeded();
  }, [loadInternalRatingIfNeeded, loadShowsIfNeeded]);

  function prevent(e) {
    e?.preventDefault();
    e?.stopPropagation();
  }

  const getIconColor = (data) => {
    if (data?.smsOptedOut) {
      return "#c13232ff"; // Softer red
    }
    if (
      data?.smsPermissionStatus === true &&
      data?.smsConsentStatusBySms === false
    ) {
      return "#ff8400ff"; // Softer orange
    }
    if (data?.smsConsentStatusBySms === false) {
      return "#ffe68bff"; // Softer yellow
    }

    return "#61b964ff"; // Green
  };

  const getToolTipTitle = (data) => {
    if (data?.smsOptedOut) {
      return "User has opted out of SMS communication.";
    }
    if (
      data?.smsPermissionStatus === true &&
      data?.smsConsentStatusBySms === false
    ) {
      return "User has given SMS permission but not consented via SMS.";
    }
    if (data?.smsConsentStatusBySms === false) {
      return "User has not given SMS consent.";
    }
    return "Send SMS";
  };

  const setupEditContractorHandler = ({ contractorId }) => {
    dispatch({
      type: SETUP_EDIT_CONTRACTOR_REQUEST,
    });

    dispatch(
      getContractorByIdAction({
        contractorId,
        successCallback: ({ response: contractorResponse }) => {
          dispatch(
            getAllPositions({
              successCallback: ({ response: allPositionsResponse }) => {
                prefillEditContractorFlowHandler({
                  contractor: contractorResponse?.data?.data,
                  allPositions: allPositionsResponse?.data?.data?.positions,
                  dispatch,
                });
              },
            }),
          );
        },
        failureCallback: () => {
          dispatch({
            type: SETUP_EDIT_CONTRACTOR_FAILURE,
          });
        },
      }),
    );

    setShowAddContractorsModal((showAddContractorsModal) => {
      return {
        ...showAddContractorsModal,
        show: true,
        isEditing: true,
      };
    });
  };

  const closeAddContractorModalHandler = useCallback(() => {
    setShowAddContractorsModal({ ...showAddContractorsModalInit });
    dispatch({
      type: CLEAR_ADD_CONTRACTOR,
    });
    if (closeAddContractorModalHandlerCallback) {
      closeAddContractorModalHandlerCallback?.(updatedData);
    }
  }, [
    closeAddContractorModalHandlerCallback,
    dispatch,
    showAddContractorsModalInit,
    updatedData,
  ]);

  // No usable contact info: the card would be two "Missing Information" chips,
  // so most screens skip it entirely. `showWithoutContactInfo` opts out of that
  // skip — see the prop docs.
  if (
    disable ||
    (!getEmailSanitized({ email: data?.email }) &&
      !data?.phone &&
      !isSessionManagemnt &&
      !showWithoutContactInfo)
  ) {
    return children;
  }

  return (
    <Box>
      <Box
        onClick={(e) => {
          e.stopPropagation();
        }}
      >
        {/* Mounted OUTSIDE the tooltip content on purpose (same as the edit
            modal below): the popover unmounts as soon as the pointer leaves,
            and a modal rendered inside it would vanish mid-edit. */}
        {showRatingModal && canEditInternalRating ? (
          <SetContractorRatingModal
            open={showRatingModal}
            contractor={{
              _id: ratingContractorId,
              firstName: displayName,
              lastName: "",
            }}
            onClose={() => setShowRatingModal(false)}
          />
        ) : null}
        {showAddContractorsModal?.show && enableEditContractor ? (
          <AddContractorModal
            showAddContractorsModal={showAddContractorsModal?.show}
            closeAddContractorModalHandler={closeAddContractorModalHandler}
            heading={
              showAddContractorsModal?.isEditing
                ? "Edit Contractor"
                : showAddContractorsModal?.isViewing
                  ? "View Contractor"
                  : "Add Contractor"
            }
            isEditing={showAddContractorsModal?.isEditing}
            isViewing={showAddContractorsModal?.isViewing}
            isThirdPartyParent={false}
            successCallbacks={{
              successCallbackStep1: (data) => {
                (undefined,
                  setUpdatedData(data?.data?.data));
              },
            }}
          />
        ) : null}
      </Box>
      <CustomTooltip
        enterDelay={500}
        leaveDelay={300}
        enterNextDelay={100}
        onOpen={onCardOpen}
        arrow
        placement={placement ?? "bottom"}
        componentsProps={{
          tooltip: {
            sx: {
              maxWidth: { sm: "95vw", md: "80vw", lg: "30rem" },
            },
          },
        }}
        title={
          <Box
            data-contact-popover="true"
            onMouseDown={(e) => {
              // Real-mouse mousedown would blur the search input, which closes the
              // results dropdown (and this portaled popover) BEFORE the button's
              // click fires — so the button did nothing. preventDefault keeps the
              // input focused so the click completes; stopPropagation avoids the
              // row selecting.
              e.preventDefault();
              e.stopPropagation();
            }}
            onClick={(e) => e.stopPropagation()}
            sx={{
              display: "flex",
              justifyContent: "flex-start",
              gap: "0.2rem",
              flexDirection: "column",
            }}
          >
            <Box
              sx={{
                display: "flex",
                justifyContent:
                  !disableDetails &&
                  showMessageIcon &&
                  !isActiveRole(USER_ROLES.FREELANCE_EC)
                    ? "space-between"
                    : "center",
                alignItems: "center",
                width: "100%",
                gap: "1rem",
              }}
            >
              <Typography
                sx={{
                  fontSize: "1.15rem",
                  fontWeight: 400,
                }}
              >
                {disableDetails ? "More Options" : "Contact Information"}
              </Typography>
              {!disableDetails &&
                showMessageIcon &&
                !isActiveRole(USER_ROLES.FREELANCE_EC) &&
                (!data?.smsOptedOut ? (
                  <CustomIconButton
                    sx={{ p: 0, m: 0, mt: 1 }}
                    onMouseDown={(e) => {
                      e.preventDefault();
                      e.stopPropagation();
                    }}
                    onClick={(e) => {
                      prevent(e);
                      if (!(showSendConsetEmail || showSmsConset)) {
                        prevent(e);
                        dispatch(
                          openSendSmsModalDirectAction({
                            isDM,
                            people: [
                              {
                                _id:
                                  rowData?.outSourceContractorId ||
                                  rowData?.contractorId ||
                                  rowData?.assignedContractor ||
                                  rowData?._id,
                                name: data?.name,
                                email: data?.email,
                                userRole: USER_ROLES.CONTRACTOR,
                                senderId: loggedInUser?.userId,
                              },
                            ],
                          }),
                        );
                        return;
                      }

                      if (getEmailSanitized({ email: rowData?.email }) == "") {
                        dispatch(
                          alertDialogAciton({
                            open: true,
                            title: "Missing Information",
                            message:
                              "Email information is missing. Please add an email address to continue.",
                          }),
                        );
                        return;
                      }

                      dispatch(
                        alertDialogAciton({
                          open: true,
                          title: "User Consent Required",
                          message: showSendConsetEmail
                            ? "The following user have not given consent to send SMS, Send email asking to login and provide consent."
                            : showSmsConset
                              ? "The following user have not given consent to sent SMS, Send SMS requesting consent for SMS communication."
                              : null,
                          onOk: () => {
                            if (showSendConsetEmail) {
                              dispatch(
                                triggerEmailConsentAction({
                                  payload: {
                                    data: {
                                      emails: [
                                        {
                                          id:
                                            rowData?.outSourceContractorId ||
                                            rowData?.contractorId ||
                                            rowData?.assignedContractor ||
                                            rowData?._id,
                                          name: data?.name,
                                          email: data?.email,
                                        },
                                      ],
                                    },
                                  },
                                }),
                              );
                            } else if (showSmsConset) {
                              dispatch(
                                triggerSmsConsentAction({
                                  payload: {
                                    data: {
                                      userIds: [
                                        {
                                          id:
                                            rowData?.outSourceContractorId ||
                                            rowData?.contractorId ||
                                            rowData?.assignedContractor ||
                                            rowData?._id,
                                        },
                                      ],
                                    },
                                  },
                                }),
                              );
                            }
                          },
                          okLabel: showSendConsetEmail
                            ? "Send Consent Email"
                            : showSmsConset
                              ? "Send SMS Consent"
                              : null,
                        }),
                      );
                    }}
                  >
                    <Tooltip title={getToolTipTitle(data)}>
                      <Textsms sx={{ color: getIconColor(data), m: 0, p: 0 }} />
                    </Tooltip>
                  </CustomIconButton>
                ) : (
                  <Tooltip title={getToolTipTitle(data)}>
                    <CustomIconButton onMouseDown={(e) => { e.preventDefault(); e.stopPropagation(); }}>
                      <Textsms
                        sx={{
                          color: getIconColor(data),
                          cursor: "not-allowed",
                          m: 0,
                          p: 0,
                        }}
                      />
                    </CustomIconButton>
                  </Tooltip>
                ))}
            </Box>
            <Divider
              orientation="horizontal"
              sx={{ borderColor: "#ffffff7d", width: "100%" }}
            />

            {/* {missingInformation && ( */}
            {/*   <Alert */}
            {/*     severity="warning" */}
            {/*     sx={{ */}
            {/*       py: "0", */}
            {/*       px: 1, */}
            {/*       backgroundColor: alpha("#ff9800", 0.2), */}
            {/*       color: "#ffa726", */}
            {/*       "& .MuiAlert-icon": { */}
            {/*         color: "#ffa726", */}
            {/*       }, */}
            {/*     }} */}
            {/*   > */}
            {/*     Missing Information */}
            {/*   </Alert> */}
            {/* )} */}
            {!disableDetails && (
              <Box
                onClick={(e) => {
                  e.stopPropagation();
                }}
                sx={{
                  display: "flex",
                  justifyContent: "flex-start",
                  alignItems: "flex-start",
                  gap: "0.25rem",
                  flexDirection: "column",
                }}
              >
                {showName && (
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "flex-start",
                      width: "100%",
                    }}
                  >
                    <Typography
                      sx={{
                        "& p": {
                          display: "inline-flex",
                        },
                      }}
                    >
                      <Typography
                        sx={{
                          color: getCssVariableHandler({
                            variableName: "--primary-pink-hex",
                          }),
                        }}
                      >
                        Name :
                      </Typography>{" "}
                      <Typography
                        sx={{
                          color:
                            getContractorAlertTextColor({ data: rowData }) ??
                            "inherit",
                        }}
                      >
                        {displayName ?? "N/A"}
                      </Typography>
                      <CopyButton value={displayName} variant="short" />
                    </Typography>
                    {enableEditContractor &&
                    isUserRole(
                      USER_ROLES.SUPERADMIN,
                      USER_ROLES.ADMIN,
                      USER_ROLES.COORDINATOR,
                    ) ? (
                      <IconButton
                        onClick={() => {
                          setupEditContractorHandler({
                            contractorId:
                              rowData?.outSourceContractorId ||
                              rowData?.contractorId ||
                              rowData?.assignedContractor ||
                              rowData?._id,
                          });
                        }}
                        sx={{ p: 0, m: 0, ml: 1 }}
                        color="primary"
                      >
                        <Edit sx={{ fontSize: "1.15rem" }} />
                      </IconButton>
                    ) : null}
                  </Box>
                )}

                <Typography
                  sx={{
                    // "& p": {
                    display: "inline-flex",
                    alignItems: "center",
                    // },
                  }}
                >
                  <Typography
                    sx={{
                      color: getCssVariableHandler({
                        variableName: "--primary-pink-hex",
                      }),
                    }}
                  >
                    Mobile :
                  </Typography>{" "}
                  <Typography>
                    {" "}
                    {phoneNumberFormat(data?.phone) || (
                      <Box
                        sx={{
                          display: "inline-flex",
                          alignItems: "center",
                          gap: "0.25rem",
                          backgroundColor: alpha("#ff9800", 0.15),
                          color: "#ffa726",
                          borderRadius: "4px",
                          padding: "2px 8px",
                          fontSize: "0.8rem",
                          ml: "0.25rem",
                        }}
                      >
                        <WarningAmberIcon sx={{ fontSize: "1rem" }} />
                        Missing Information
                      </Box>
                    )}
                  </Typography>
                  <CopyButton value={data?.phone} variant="short" />
                </Typography>

                {/* Home city/state and proficient roles sit right under the
                    phone — client request 2026-08-12. Both are hidden when
                    empty rather than showing "N/A": on a card this dense an
                    empty row costs more than the missing information. */}
                {Boolean(homeLocation) && (
                  <Typography
                    sx={{
                      "& p": {
                        display: "inline-flex",
                      },
                    }}
                  >
                    <Typography
                      sx={{
                        color: getCssVariableHandler({
                          variableName: "--primary-pink-hex",
                        }),
                      }}
                    >
                      Home :
                    </Typography>{" "}
                    <Typography>{homeLocation}</Typography>
                    <CopyButton value={homeLocation} variant="short" />
                  </Typography>
                )}

                {proficientRoles.length > 0 && (
                  <Typography
                    sx={{
                      display: "inline-flex",
                      alignItems: "center",
                      flexWrap: "wrap",
                      gap: "0.25rem",
                    }}
                  >
                    <Typography
                      sx={{
                        color: getCssVariableHandler({
                          variableName: "--primary-pink-hex",
                        }),
                      }}
                    >
                      Roles :
                    </Typography>{" "}
                    <Typography>{proficientRoles.join(", ")}</Typography>
                    {extraRolesCount > 0 && (
                      <Typography sx={{ opacity: 0.7 }}>
                        +{extraRolesCount}
                      </Typography>
                    )}
                  </Typography>
                )}

                {showPreferredName && Boolean(preferredDisplay) && (
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "flex-start",
                      width: "100%",
                    }}
                  >
                    <Typography
                      sx={{
                        "& p": {
                          display: "inline-flex",
                        },
                      }}
                    >
                      <Typography
                        sx={{
                          color: getCssVariableHandler({
                            variableName: "--primary-pink-hex",
                          }),
                        }}
                      >
                        Preferred Name :
                      </Typography>{" "}
                      <Typography>{preferredDisplay || "N/A"}</Typography>
                      {Boolean(preferredDisplay) && (
                        <CopyButton
                          value={preferredDisplay}
                          variant="short"
                        />
                      )}
                    </Typography>
                  </Box>
                )}
                {[
                  "V.C.",
                  "w2",
                  CONTRACTOR_TYPE_3RD_PARTY.THIRD_PARTY,
                ]?.includes(contractorType) && (
                  <Typography
                    sx={{
                      "& p": {
                        display: "inline-flex",
                      },
                    }}
                  >
                    <Typography
                      sx={{
                        color: getCssVariableHandler({
                          variableName: "--primary-pink-hex",
                        }),
                      }}
                    >
                      Company Name :
                    </Typography>{" "}
                    <Typography>{rowData?.companyName ?? "N/A"}</Typography>
                  </Typography>
                )}
                {contractorType && (
                  <Typography
                    sx={{
                      "& p": {
                        display: "inline-flex",
                      },
                    }}
                  >
                    <Typography
                      sx={{
                        color: getCssVariableHandler({
                          variableName: "--primary-pink-hex",
                        }),
                      }}
                    >
                      Contractor Type :
                    </Typography>{" "}
                    <Typography>{contractorType ?? "N/A"}</Typography>
                  </Typography>
                )}

                {contractorId && (
                  <Typography
                    sx={{
                      "& p": {
                        display: "inline-flex",
                      },
                    }}
                  >
                    <Typography
                      sx={{
                        color: getCssVariableHandler({
                          variableName: "--primary-pink-hex",
                        }),
                      }}
                    >
                      Contractor ID :
                    </Typography>{" "}
                    <Typography>{contractorId ?? "N/A"}</Typography>
                    <CopyButton value={contractorId} variant="short" />
                  </Typography>
                )}

                {workmarketId && (
                  <Typography
                    sx={{
                      "& p": {
                        display: "inline-flex",
                      },
                    }}
                  >
                    <Typography
                      sx={{
                        color: getCssVariableHandler({
                          variableName: "--primary-pink-hex",
                        }),
                        display: "flex",
                        alignItems: "center",
                      }}
                    >
                      Workmarket Id :
                    </Typography>{" "}
                    {workmarketId == "NA" ? (
                      <Box
                        sx={{
                          display: "inline-flex",
                          alignItems: "center",
                          gap: "0.25rem",
                          backgroundColor: alpha("#ff9800", 0.15),
                          color: "#ffa726",
                          borderRadius: "4px",
                          padding: "0px 8px",
                          fontSize: "1rem",
                          // ml: "0.25rem",
                        }}
                      >
                        <WarningAmberIcon sx={{ fontSize: "1rem" }} />
                        Missing Id
                      </Box>
                    ) : (
                      <>
                        <Typography>{workmarketId ?? "N/A"}</Typography>
                        <CopyButton value={workmarketId} variant="short" />
                      </>
                    )}
                  </Typography>
                )}

                {!isUserRole(
                  USER_ROLES.FREELANCE_EC,
                  USER_ROLES.CLIENT,
                  USER_ROLES.CONTRACTOR,
                ) && (
                  <Typography
                    sx={{
                      "& p": {
                        display: "inline-flex",
                      },
                    }}
                  >
                    <Typography
                      sx={{
                        color: getCssVariableHandler({
                          variableName: "--primary-pink-hex",
                        }),
                      }}
                    >
                      HR Approved :
                    </Typography>{" "}
                    <Typography>
                      {rowData?.isGustoApproved ? "Approved" : "N/A"}
                    </Typography>
                  </Typography>
                )}

                <Typography
                  sx={{
                    // "& p": {
                    display: "inline-flex",
                    alignItems: "center",
                    // },
                  }}
                >
                  <Typography
                    sx={{
                      color: getCssVariableHandler({
                        variableName: "--primary-pink-hex",
                      }),
                      lineHeight: 1,
                    }}
                  >
                    Email :
                  </Typography>{" "}
                  <Typography>
                    {getEmailSanitized({ email: data?.email }) || (
                      <Box
                        sx={{
                          display: "inline-flex",
                          alignItems: "center",
                          gap: "0.25rem",
                          backgroundColor: alpha("#ff9800", 0.15),
                          color: "#ffa726",
                          borderRadius: "4px",
                          padding: "2px 8px",
                          fontSize: "0.8rem",
                          ml: "0.25rem",
                        }}
                      >
                        <WarningAmberIcon sx={{ fontSize: "1rem" }} />
                        Missing Information
                      </Box>
                    )}
                  </Typography>
                  <CopyButton
                    value={getEmailSanitized({ email: data?.email })}
                    variant="short"
                  />
                </Typography>


                {smsConsentInfo &&
                  isUserRole(
                    USER_ROLES.SUPERADMIN,
                    USER_ROLES.ADMIN,
                    USER_ROLES.COORDINATOR,
                  ) && (
                    <Box sx={{ mt: "0.25rem", mb: "0.25rem" }}>
                      <Box
                        sx={{
                          display: "inline-flex",
                          alignItems: "center",
                          gap: "0.25rem",
                          backgroundColor: alpha(smsConsentInfo.color, 0.15),
                          color: smsConsentInfo.color,
                          borderRadius: "4px",
                          padding: "2px 8px",
                          fontSize: "0.75rem",
                          fontWeight: 600,
                        }}
                      >
                        SMS: {smsConsentInfo.label}
                      </Box>
                      {smsConsentInfo.hint && (
                        <Typography
                          sx={{
                            fontSize: "0.7rem",
                            opacity: 0.75,
                            mt: "0.15rem",
                            lineHeight: 1.35,
                            maxWidth: "260px",
                          }}
                        >
                          {smsConsentInfo.hint}
                        </Typography>
                      )}
                    </Box>
                  )}

                {isUserRole(
                  USER_ROLES.SUPERADMIN,
                  USER_ROLES.ADMIN,
                  USER_ROLES.COORDINATOR,
                ) && (
                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: "column",
                      gap: "0.25rem",
                      width: "100%",
                    }}
                  >
                    <Box
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        gap: "0.5rem",
                        flexWrap: "wrap",
                      }}
                    >
                      <Typography
                        sx={{
                          color: getCssVariableHandler({
                            variableName: "--primary-pink-hex",
                          }),
                        }}
                      >
                        Internal Rating :
                      </Typography>
                      {/* Clicking a star opens the same modal the Contractors
                          page uses, instead of writing on hover: a stray mouse
                          move over a tooltip must never change a rating, and
                          the modal is where notes are written and removed. */}
                      <Tooltip
                        title={
                          canEditInternalRating
                            ? "Click to change the rating or add a note"
                            : ""
                        }
                      >
                        <Box
                          component="span"
                          sx={{ display: "inline-flex" }}
                          onMouseDown={(e) => {
                            e.preventDefault();
                            e.stopPropagation();
                          }}
                          onClick={(e) => {
                            if (!canEditInternalRating) return;
                            prevent(e);
                            setShowRatingModal(true);
                          }}
                        >
                          <Rating
                            value={Number(internalRating?.score) || 0}
                            readOnly
                            precision={0.5}
                            size="small"
                            sx={{
                              cursor: canEditInternalRating
                                ? "pointer"
                                : "default",
                              "& .MuiRating-iconEmpty": {
                                color: "rgba(255,255,255,0.35)",
                              },
                            }}
                          />
                        </Box>
                      </Tooltip>
                      {/* "set by" and not just the bare name: each note below
                          carries its own author, and the two are not the same
                          person whenever somebody only moves the stars. */}
                      {internalRating?.updatedBy?.name && (
                        <Typography
                          sx={{ fontSize: "0.8rem", opacity: 0.7 }}
                        >
                          set by {internalRating.updatedBy.name}
                        </Typography>
                      )}
                    </Box>

                    {/* Client request 2026-08-13: the note shows right under the
                        rating, with who wrote it. Full text, capped block —
                        a long history scrolls instead of pushing the popup off
                        screen. Read-only here: removing lives in the modal,
                        because this popover unmounts on pointer leave. */}
                    {Array.isArray(internalRating?.notes) &&
                      internalRating.notes.length > 0 && (
                        <ContractorRatingNotes
                          notes={internalRating.notes}
                          variant="card"
                          maxHeight="11rem"
                          emptyLabel=""
                        />
                      )}
                  </Box>
                )}

                {rowData?.isContractorFlagged && (
                  <Typography
                    sx={{
                      display: "flex",
                      alignItems: "flex-start",
                      gap: "0.25rem",
                      flexWrap: "nowrap",
                      whiteSpace: "nowrap",
                    }}
                  >
                    {" "}
                    <Typography
                      component={"span"}
                      sx={{
                        color: getCssVariableHandler({
                          variableName: "--primary-pink-hex",
                        }),
                      }}
                    >
                      Flagged Remark :
                    </Typography>{" "}
                    <Typography
                      sx={{
                        display: "flex",
                        gap: "0.5rem",
                        wordBreak: "break-word",
                        whiteSpace: "normal",
                      }}
                    >
                      {rowData?.flaggedRemark ?? "N/A"}
                      {!hideRemarkEditButtons && (
                      <CustomIconButton
                        sx={{ padding: "0 !important" }}
                        onClick={(e) => {
                          e.preventDefault();
                          e.stopPropagation();
                          dispatch(
                            openReportModalAction({
                              payload: {
                                name: data?.name,
                                preferredName: rowData?.preferredName,
                                _id:
                                  rowData?.assignedContractor || rowData?._id,
                                remark: rowData?.flaggedRemark || "",
                                successCallback: () => {
                                  if (isEventDetails) {
                                    dispatch(
                                      refreshPositionAction({
                                        eventId: eventInfo?._id,
                                      }),
                                    );
                                  } else {
                                    afterEditFlaggedRemark?.();
                                  }
                                },
                              },
                            }),
                          );
                        }}
                      >
                        <Edit sx={{ fontSize: "1rem" }} />
                      </CustomIconButton>
                      )}
                    </Typography>
                  </Typography>
                )}

                {rowData?.isContractorRestricted && (
                  <Typography
                    sx={{
                      display: "flex",
                      alignItems: "flex-start",
                      gap: "0.25rem",
                      flexWrap: "nowrap",
                      whiteSpace: "nowrap",
                    }}
                  >
                    {" "}
                    <Typography
                      component={"span"}
                      sx={{
                        color: getCssVariableHandler({
                          variableName: "--primary-pink-hex",
                        }),
                      }}
                    >
                      Restricted Remark :
                    </Typography>{" "}
                    <Typography
                      sx={{
                        display: "flex",
                        gap: "0.5rem",
                        wordBreak: "break-word",
                        whiteSpace: "normal",
                      }}
                    >
                      {rowData?.restrictedRemark ?? "N/A"}
                      {!hideRemarkEditButtons && (
                      <CustomIconButton
                        sx={{ padding: "0 !important" }}
                        onClick={(e) => {
                          e.preventDefault();
                          e.stopPropagation();
                          dispatch(
                            openReportModalAction({
                              payload: {
                                name: data?.name,
                                title: "Restrict Contractor",
                                preferredName: rowData?.preferredName,
                                isRestrictPopup: true,
                                _id:
                                  rowData?.assignedContractor || rowData?._id,
                                remark: rowData?.restrictedRemark || "",
                                successCallback: () => {
                                  if (isEventDetails) {
                                    dispatch(
                                      refreshPositionAction({
                                        eventId: eventInfo?._id,
                                      }),
                                    );
                                  } else {
                                    afterEditFlaggedRemark?.();
                                  }
                                },
                              },
                            }),
                          );
                        }}
                      >
                        <Edit sx={{ fontSize: "1rem" }} />
                      </CustomIconButton>
                      )}
                    </Typography>
                  </Typography>
                )}

                {data?.address && (
                  <Typography
                    sx={{
                      "& p": {
                        display: "inline-flex",
                      },
                    }}
                  >
                    <Typography
                      sx={{
                        color: getCssVariableHandler({
                          variableName: "--primary-pink-hex",
                        }),
                      }}
                    >
                      Address :
                    </Typography>{" "}
                    <Typography>{data?.address}</Typography>
                  </Typography>
                )}

                {/* Shows worked — client request 2026-08-21. Sits BELOW the
                    flagged/restricted remarks on purpose: those are warnings an
                    admin must not have to scroll past a ten-row list to reach.
                    Renders nothing when the person has no shows. */}
                {canSeeShows && (
                  <ContractorShows entry={showsEntry} loading={showsLoading} />
                )}

                {shouldShowContracts && (
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "center",
                      // alignItems: "center",
                      width: "100%",
                    }}
                  >
                    <UnderlineButton
                      styles={{
                        fontSize: "1rem !important",
                      }}
                      title={"View Documents"}
                      onClick={() => {
                        dispatch(
                          openViewDocumentModalAction({
                            payload:
                              rowData?.outSourceContractorId ||
                              rowData?.contractorId ||
                              rowData?.assignedContractor ||
                              rowData?._id ||
                              rowData?.id,
                          }),
                        );
                      }}
                    />
                  </Box>
                )}

                {!hideApprovalsButton &&
                  isUserRole(
                    USER_ROLES.SUPERADMIN,
                    USER_ROLES.ADMIN,
                    USER_ROLES.COORDINATOR,
                  ) && (
                    <Box
                      sx={{
                        display: "flex",
                        justifyContent: "center",
                        // alignItems: "center",
                        width: "100%",
                      }}
                    >
                      <UnderlineButton
                        styles={{
                          fontSize: "1rem !important",
                        }}
                        title={"Manage Approvals"}
                        onClick={() => {
                          dispatch(
                            openManageApprovalModalAction({
                              payload: {
                                contractorId:
                                  rowData?.outSourceContractorId ||
                                  rowData?.contractorId ||
                                  rowData?.assignedContractor ||
                                  rowData?._id ||
                                  rowData?.id,
                              },
                            }),
                          );
                        }}
                      />
                    </Box>
                  )}
              </Box>
            )}
            {/* {showConsentBtns && !isThirdParty && ( */}
            {/*   <Box */}
            {/*     sx={{ */}
            {/*       display: "flex", */}
            {/*       gap: "0.25rem", */}
            {/*     }} */}
            {/*   > */}
            {/*     {isEventDetails && ( */}
            {/*       <UnderlineButton */}
            {/*         title={"Compose SMS"} */}
            {/*         onClick={(e) => { */}
            {/*           prevent(e); */}
            {/*           dispatch( */}
            {/*             dispatch( */}
            {/*               openSendSmsModalDirectAction({ */}
            {/*                 people: [ */}
            {/*                   { */}
            {/*                     _id: rowData?.assignedContractor || rowData?._id, */}
            {/*                     name: data?.name, */}
            {/*                     email: data?.email, */}
            {/*                     userRole: USER_ROLES.CONTRACTOR, */}
            {/*                   }, */}
            {/*                 ], */}
            {/*               }), */}
            {/*             ), */}
            {/*           ); */}
            {/*         }} */}
            {/*         styles={{ */}
            {/*           fontSize: "1rem", */}
            {/*         }} */}
            {/*       /> */}
            {/*     )} */}
            {/**/}
            {/*     <UnderlineButton */}
            {/*       title={"Direct SMS"} */}
            {/*       onClick={(e) => { */}
            {/*         prevent(e); */}
            {/*         dispatch( */}
            {/*           dispatch( */}
            {/*             openDirectSMSModalAction({ */}
            {/*               payload: { */}
            {/*                 data: [ */}
            {/*                   { */}
            {/*                     _id: rowData?.assignedContractor || rowData?._id, */}
            {/*                     name: data?.name, */}
            {/*                   }, */}
            {/*                 ], */}
            {/*               }, */}
            {/*             }), */}
            {/*           ), */}
            {/*         ); */}
            {/*       }} */}
            {/*       styles={{ */}
            {/*         fontSize: "1rem", */}
            {/*       }} */}
            {/*     /> */}
            {/*   </Box> */}
            {/* )} */}
            {/* {showConsentBtns && !isThirdParty && ( */}
            {/*   <Box */}
            {/*     sx={{ */}
            {/*       display: "flex", */}
            {/*       gap: "0.25rem", */}
            {/*     }} */}
            {/*   > */}
            {/*     {showSendConsetEmail && ( */}
            {/*       <UnderlineButton */}
            {/*         showUnderline={!consetEmailLoading} */}
            {/*         title={ */}
            {/*           consetEmailLoading ? ( */}
            {/*             <CircularProgress sx={{ fontSize: "1.25rem" }} /> */}
            {/*           ) : ( */}
            {/*             <CustomHelper */}
            {/*               isText={true} */}
            {/*               message={ */}
            {/*                 "Send email asking contractor to log in and provide consent" */}
            {/*               } */}
            {/*             > */}
            {/*               Send Consent Email */}
            {/*             </CustomHelper> */}
            {/*           ) */}
            {/*         } */}
            {/*         onClick={(e) => { */}
            {/*           prevent(e); */}
            {/*           dispatch( */}
            {/*             triggerEmailConsentAction({ */}
            {/*               payload: { */}
            {/*                 data: { */}
            {/*                   emails: [ */}
            {/*                     { */}
            {/*                       name: data?.name, */}
            {/*                       email: data?.email, */}
            {/*                     }, */}
            {/*                   ], */}
            {/*                 }, */}
            {/*               }, */}
            {/*             }), */}
            {/*           ); */}
            {/*         }} */}
            {/*         styles={{ */}
            {/*           fontSize: "1rem", */}
            {/*         }} */}
            {/*       /> */}
            {/*     )} */}
            {/*     {showSmsConset && ( */}
            {/*       <UnderlineButton */}
            {/*         showUnderline={!consetSMSLoading} */}
            {/*         title={ */}
            {/*           consetSMSLoading ? ( */}
            {/*             <CircularProgress */}
            {/*               size={20} */}
            {/*               sx={{ */}
            {/*                 color: getCssVariableHandler({ */}
            {/*                   variableName: "--primary-pink-hex", */}
            {/*                 }), */}
            {/*               }} */}
            {/*             /> */}
            {/*           ) : ( */}
            {/*             <CustomHelper */}
            {/*               isText={true} */}
            {/*               message={ */}
            {/*                 "Send SMS requesting contractor's consent for SMS communication" */}
            {/*               } */}
            {/*             > */}
            {/*               Send SMS Consent */}
            {/*             </CustomHelper> */}
            {/*           ) */}
            {/*         } */}
            {/*         onClick={(e) => { */}
            {/*           prevent(e); */}
            {/*           dispatch( */}
            {/*             triggerSmsConsentAction({ */}
            {/*               payload: { */}
            {/*                 data: { */}
            {/*                   userIds: [ */}
            {/*                     { */}
            {/*                       id: rowData?.assignedContractor || rowData?._id, */}
            {/*                     }, */}
            {/*                   ], */}
            {/*                 }, */}
            {/*               }, */}
            {/*             }), */}
            {/*           ); */}
            {/*         }} */}
            {/*         styles={{ */}
            {/*           fontSize: "1rem", */}
            {/*         }} */}
            {/*       /> */}
            {/*     )} */}
            {/*   </Box> */}
            {/* )} */}
            <Divider
              orientation="horizontal"
              sx={{ borderColor: "#ffffff7d", width: "100%" }}
            />
            {bottomComponent && bottomComponent}
          </Box>
        }
      >
        {children}
      </CustomTooltip>
    </Box>
  );
};

ContactTool.propTypes = {
  children: PropTypes.any,
  data: PropTypes.object,
  disable: PropTypes.bool,
  placement: PropTypes.string,
  bottomComponent: PropTypes.any,
  showName: PropTypes.bool,
  disableDetails: PropTypes.bool,
  showConsentBtns: PropTypes.bool,
  rowData: PropTypes.object,
  isEventDetails: PropTypes.bool,
  afterEditFlaggedRemark: PropTypes.func,
  enableEditContractor: PropTypes.bool,
  closeAddContractorModalHandlerCallback: PropTypes.func,
  isDM: PropTypes.bool,
  showPreferredName: PropTypes?.bool,
  hideApprovalsButton: PropTypes?.bool,
  hideRemarkEditButtons: PropTypes?.bool,
  showWithoutContactInfo: PropTypes?.bool,
};
